
import {Component, Mixins, Watch, Prop} from "vue-property-decorator";
import Dates from "@/components/inputs/Dates.vue";
import TakipTipiPicker from "@/components/pickers/TakipTipiPicker.vue";
import TakipAltTipiPicker from "@/components/pickers/TakipAltTipiPicker.vue";
import TakipYoluPicker from "@/components/pickers/TakipYoluPicker.vue";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import {TakipYolu} from "@/enum/TakipYolu";
import MahiyetPicker from "@/components/pickers/MahiyetPicker.vue";
import {TakipTipi} from "@/enum/TakipTipi";
import {TakipDurumu} from "@/enum/TakipDurumu";

@Component({
  components: {
    MahiyetPicker,
    Dates,
    TakipTipiPicker,
    TakipAltTipiPicker,
    TakipYoluPicker,
  },
})
export default class TakipTalebiForm extends Mixins(SimpleInputMixin) {
  takipYolu = TakipYolu;
  takipTipi = TakipTipi;

  // Önceki takip yolu değerini tutacak değişken
  previousTakipYoluId: any = null;
  
  @Prop({ default: () => [] }) alacaklar!: any;

  get hasAlacaklar(): boolean {

    if (!this.alacaklar) return false;

    // Array ise
    if (Array.isArray(this.alacaklar)) {
      return this.alacaklar.length > 0;
    }

    // Object içinde data property'si varsa
    if (typeof this.alacaklar === 'object' && this.alacaklar.data && Array.isArray(this.alacaklar.data)) {
      return this.alacaklar.data.length > 0;
    }

    // Object ise ve boş değilse
    if (typeof this.alacaklar === 'object' && Object.keys(this.alacaklar).length > 0) {
      return true;
    }

    return false;
  }

  // Bileşen oluşturulduğunda önceki takip yolu değerini kaydet
  mounted() {
    this.previousTakipYoluId = this.localValue.takip_yolu_id;
  }

  // Takip yolu değiştiğinde çağrılacak metot
  onTakipYoluChange(newValue: any) {
    // Değer gerçekten değiştiyse ve önceki değer kayıtlıysa
    if (this.previousTakipYoluId !== null && newValue !== this.previousTakipYoluId) {
      // Takip yolu değişikliği olayını emit et
      this.$emit('takip-yolu-changed', {
        yoluId: newValue,
        formData: {
          manuel_takip_yolu: this.localValue.manuel_takip_yolu
        },
        previousYoluId: this.previousTakipYoluId
      });
    }
    
    // Önceki değeri güncelle
    this.previousTakipYoluId = newValue;
    
    // Manuel takip yolu kontrolü
    if (newValue !== this.takipYolu.diger) {
      this.localValue.manuel_takip_yolu = null;
    }
  }

  @Watch('localValue.takip_tipi_id')
  onTakipTipiChange() {
    if (!(this.mahiyetVarMi))
      this.localValue.takip_mahiyeti_id = null;

    if (!this.localValue.id && this.localValue.takip_tipi_id === this.takipTipi.adiKira) {
      this.$nextTick(() => {
        this.localValue.takip_yolu_id = this.takipYolu.haciz_tahliye;
        this.input();
      });
    } else if (!this.localValue.id && this.localValue.takip_tipi_id === this.takipTipi.tahliye) {
      this.$nextTick(() => {
        this.localValue.takip_yolu_id = this.takipYolu.tahliye;
        this.input();
      });
    } else if (
      !this.localValue.id &&
      (this.localValue.takip_tipi_id === this.takipTipi.ipotekIcraEmri ||
        this.localValue.takip_tipi_id === this.takipTipi.ipotekOdemeEmri)
    ) {
      this.$nextTick(() => {
        this.localValue.takip_yolu_id = this.takipYolu.ipoteginPrayaCevrilmesi;
        this.input();
      });
    } else if (
      !this.localValue.id &&
      (this.localValue.takip_tipi_id === this.takipTipi.tasinirRehni ||
        this.localValue.takip_tipi_id === this.takipTipi.menkulRehni)
    ) {
      this.$nextTick(() => {
        this.localValue.takip_yolu_id = this.takipYolu.rehninParayaCevrilmesi;
        this.input();
      });
    } else if (
      !this.localValue.id &&
      (this.localValue.takip_tipi_id === this.takipTipi.kambiyoSenetleriyleIflas ||
        this.localValue.takip_tipi_id === this.takipTipi.iflas)
    ) {
      this.$nextTick(() => {
        this.localValue.takip_yolu_id = this.takipYolu.iflas;
        this.input();
      });
    } else if (!this.localValue.id && this.localValue.takip_tipi_id === this.takipTipi.menkulTeslimi) {
      this.$nextTick(() => {
        this.localValue.takip_yolu_id = this.takipYolu.hacizTahliye;
        this.input();
      });
    } else if (!this.localValue.id && this.localValue.takip_tipi_id === this.takipTipi.cocukTeslimi) {
      this.$nextTick(() => {
        this.localValue.takip_yolu_id = this.takipYolu.cocukTeslimi;
        this.input();
      });
    }
  }
  get mahiyetVarMi() {
    return (this.localValue.takip_tipi_id == this.takipTipi.ilamsiz || this.localValue.takip_tipi_id == this.takipTipi.paraBorcuVeyaTeminat);
  }

}
